import React, { useState } from "react";
import { supabase } from "../supabaseClient";

export default function ChangePassword() {
	const [new_password, setPassword] = useState("");
	const [confirm, setConfirm] = useState("");
	const [error, setError] = useState("");
	const [success, setSuccess] = useState("");
	const [loading, setLoading] = useState(false);

	async function handleChange(e) {
		e.preventDefault();
		setError("");
		setSuccess("");
		if (!new_password || new_password !== confirm) {
			setError("Passwords do not match.");
			return;
		}
		setLoading(true);
		const { data, error } = await supabase.auth.updateUser({ password: new_password });
		setLoading(false);
		if (error) setError(error.message);
		else {
			setPassword("");
			setConfirm("");
			setSuccess("Password updated!");
		}
	}

	return (
		<form onSubmit={handleChange} className="space-y-4 w-full mt-10">
			<h3 className="text-lg font-bold">Change Password</h3>
			<input
				type="password"
				className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring"
				placeholder="New password"
				value={new_password}
				onChange={(e) => setPassword(e.target.value)}
				autoComplete="new-password"
				required
			/>
			<input
				type="password"
				className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring"
				placeholder="Confirm new password"
				value={confirm}
				onChange={(e) => setConfirm(e.target.value)}
				autoComplete="new-password"
				required
			/>
			{error && <div className="text-red-500">{error}</div>}
			{success && <div className="text-green-500">{success}</div>}
			<button className="px-6 py-2 rounded-xl bg-black text-white font-semibold shadow hover:bg-gray-900 transition" type="submit" disabled={loading}>
				{loading ? "Changing..." : "Change Password"}
			</button>
		</form>
	);
}
